import get from 'lodash/get';
import { stringInputSpec, colorPicker } from './editing-configs';

import getValidColor from './get-valid-color';

const getTextColor = (options) => {
  // since the implementation of the color picker, we can simply return the
  // textColor prop if it's a valid hex color
  if (options?.textColor?.startsWith('#')) {
    return { textColor: options.textColor };
  }
  if (options?.textColor === 'HEXCOLOR') {
    return { textColor: options.hexColor, isHex: true };
  }
  return { textColor: getValidColor(options?.textColor) || '', isHex: false };
};

getTextColor.getEditingConfig = (
  componentDocument,
  fieldName,
  label,
  hexColorLabelOverride,
  nestedPath
) => {
  const baseName = fieldName || 'textColorOptions';
  const hexColorLabel = hexColorLabelOverride || 'Hex color override';

  const optionalSelect =
    get(
      componentDocument,
      // looks over 'nestedPath' to support nested path e.g: under a repeatable panel component
      `props.${nestedPath || baseName}.textColor`,
      ''
    ) === 'HEXCOLOR'
      ? [stringInputSpec(`${baseName}.hexColor`, hexColorLabel)]
      : [];
  return [colorPicker(`${baseName}.textColor`, label), ...optionalSelect];
};

export default getTextColor;
